import { store } from '../app';

export default { ...store.modules };
